"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = exports.set = void 0;

var _m = require("@mutant-ws/m");

var _cookie = require("./cookie.helper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var textToJSON = function textToJSON(source) {
  try {
    return JSON.parse(source);
  } catch (error) {
    return source;
  }
};

var settings = {
  productId: null,
  host: "https://api.mutant.love",
  other: {}
};

var set = function set() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      productId = _ref.productId,
      host = _ref.host,
      rest = _objectWithoutProperties(_ref, ["productId", "host"]);

  settings.other = (0, _m.isEmpty)(rest) ? {} : rest;

  if ((0, _m.is)(productId)) {
    settings.productId = productId;
  }

  if ((0, _m.is)(host)) {
    settings.host = host;
  }
};

exports.set = set;

var track = function track(name) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      oneTimeProductId = _ref2.productId,
      other = _objectWithoutProperties(_ref2, ["productId"]);

  var productId = (0, _m.is)(oneTimeProductId) ? oneTimeProductId : settings.productId;

  if ((0, _m.isEmpty)(productId)) {
    throw new Error("MutantNext: \"productId\" value not found. Neither settings (via set) nor call specific value found. Get ID of your product section in your profile page - getmutant.com/me.");
  }

  if ((0, _m.isEmpty)(name)) {
    throw new Error("MutantNext: \"name\" value \"".concat(name, "\" is invalid. Need a string."));
  }

  var xhr = new XMLHttpRequest();
  return new Promise(function (resolve, reject) {
    xhr.open("POST", "".concat(settings.host, "/track"));
    xhr.setRequestHeader("Content-type", "application/json; charset=UTF-8");
    xhr.send(JSON.stringify({
      name: name,
      sessionId: (0, _cookie.getSessionCookie)(),
      productId: productId,
      default: {
        url: window.location.href,
        screen: "".concat(window.screen.width, "x").concat(window.screen.height),
        scroll: "".concat(window.pageXOffset, "x").concat(window.pageYOffset),
        viewport: "".concat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0), "x").concat(Math.max(document.documentElement.clientHeight, window.innerHeight || 0))
      },
      user: _objectSpread(_objectSpread({}, settings.other), other)
    }));
    xhr.addEventListener("load", function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({
          status: xhr.status,
          response: textToJSON(xhr.response)
        });
      } else {
        reject({
          status: xhr.status,
          response: textToJSON(xhr.response)
        });
      }
    });
    xhr.addEventListener("error", function () {
      reject({
        status: xhr.status,
        response: textToJSON(xhr.response)
      });
    });
  });
};

exports.track = track;